import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import axios from '@/api'
import moment from 'moment'
import { acciones } from '@/modulos'
import { socket, state as stateSocket } from '@/plugins/sockets'
Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default new Vuex.Store({
  state: {
    user: {
      userName: '',
      IsAutenticated: false,
      accion_modulo: '[ ]',
      age: 25,
      apellido: '',
      arbol: [],
      autenticate: true,
      caja: {},
      foto: '',
      id: 0,
      id_empleado: 0,
      modulo: '[]',
      nombre: '',
      puestos: [],
      token: '',
      usuario: '',
    },
    puestoSelect: {},
    alert: {},
    dark: false,
    tikera: {
      id: 1,
      nombre: "comanda 1"
    },
    copiasTickera: "0",
    impresoraFiscal: {
      modeloImpresora: 1,
      puerto: 99,
      bAudios: 9600,
      paridad: 2,
      datos: 8,
      stopBits: 1,
      handshake: 0,
      maxTiempoEspera: 5000,
      tiempoAntesLectura: 100,
    },
    configuracionGeneral: {},
    puestoProductos: [],
    horaActual: "",
    puntoVentaFavorito: [],
    isConnected: false,
    socketMessage: ""
  },
  mutations: {
    setAlert(state, datos) {
      state.alert = datos
    },
    setUserData(state, datos) {

      const tempPuestoProductos = state.puestoProductos
      state.puestoProductos = []

      if (datos.IsAutenticated) {


        const validarAcciones = accion => {
          const valor = state.user.accion_modulo.includes(accion)

          return valor
        }

        state.user = datos;
        if (datos.arbol != undefined && datos.arbol.filter((i) => (i.id_puesto >= 0))) {
          if (state.puestoSelect?.id_puesto == undefined) {

            state.puestoSelect = datos.arbol.filter((i) => (i.id_puesto >= 0))[0]
          }
          else if (
            datos.arbol.filter((i) => (i.id_puesto >= 0 && state.puestoSelect?.id_puesto == i.id_puesto)).length == 0

          ) {

            state.puestoSelect = datos.arbol.filter((i) => (i.id_puesto >= 0))[0]
          } else {
            console.log(datos.arbol.filter((i) => (i.id_puesto >= 0 && state.puestoSelect.id_puesto == i.id_puesto)))
            console.log(datos.arbol.filter((i) => (i.id_puesto >= 0 && state.puestoSelect.id_puesto == i.id_puesto)).length)

          }
          if (validarAcciones(acciones.DASHBOARD_COMANDA_VER_COMANDA)) {
            state.puestoProductos = tempPuestoProductos

          }

        }

        const token = datos.token
        if (token) {
          console.log("creo Authorization")
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        } else {
          delete axios.defaults.headers.common["Authorization"];
          console.log("borro Authorization")
        }
      } else {
        if (state.user.usuario) {
          socket.emit('join-delete', { id_usuario: state.user.usuario })
        }

        state.user = datos;
        delete axios.defaults.headers.common["Authorization"];
        console.log("borro Authorization")
      }
    },
    setPuestoSelect(state, objeto) {
      state.puestoSelect = objeto;
    },
    setPuntoVentaFavorito(state, objeto) {
      state.puntoVentaFavorito.push(objeto);
    },
    deletePuntoVentaFavorito(state, objeto) {
      state.puntoVentaFavorito = state.puntoVentaFavorito.filter(i => i != objeto);
    },
    setPuestoProductos(state, datos) {
      state.puestoProductos = datos;
    },
    seTikera(state, datos) {
      state.tikera = datos
    },
    setImpresoraFiscal(state, datos) {
      state.impresoraFiscal = datos
    },
    setDark(state, datos) {
      state.dark = datos
    },
    setconfiguracionGeneral(state, datos) {
      state.configuracionGeneral = datos
    },
    setHoraActual(state, datos) {
      state.horaActual = datos
    },
    SetCopiaTicket(state, datos) {
      state.copiasTickera = datos
    },
    setSegundoHoraActual(state, datos) {

      var date = moment(state.horaActual)
        .add(datos, 'seconds')
      state.horaActual = date
    },

  },

  modules: {},
  plugins: [vuexLocal.plugin]
})
